module.exports = __webpack_public_path__ + "img/cow.e491ba4f.png";